var map = {
	"./Balances/Index.vue": [
		54034
	],
	"./Derivatives/Orders.vue": [
		28686,
		6146,
		8837,
		2652,
		9125,
		4412,
		8686
	],
	"./Derivatives/Trading/ConditionalOrderDetails.vue": [
		2287,
		2287
	],
	"./Derivatives/Trading/Form.vue": [
		9154,
		9154
	],
	"./Derivatives/Trading/OrderDetails.vue": [
		16798,
		6798
	],
	"./Derivatives/Trading/OrderLeverage.vue": [
		14651
	],
	"./Form/AdvancedSettings.vue": [
		31822
	],
	"./Form/CancelButton.vue": [
		61116,
		1116
	],
	"./Form/Debug.vue": [
		97774
	],
	"./Form/InputError.vue": [
		53982
	],
	"./Form/Inputs/BaseAmount.vue": [
		76564
	],
	"./Form/Inputs/Index.vue": [
		94754
	],
	"./Form/Inputs/Price.vue": [
		3694
	],
	"./Form/Inputs/QuoteAmount.vue": [
		6790
	],
	"./Form/OrderError.vue": [
		20163
	],
	"./Form/OrderInputs.vue": [
		2522
	],
	"./Form/OrderSubmit.vue": [
		49360
	],
	"./Form/OrderTypeSelect.vue": [
		43324
	],
	"./Form/PercentageOptions.vue": [
		45562
	],
	"./Form/TradeExecutionTypeButtons.vue": [
		76945
	],
	"./Layout.vue": [
		92914
	],
	"./Market/Chart/Index.vue": [
		24611
	],
	"./Market/Chart/TradingView.vue": [
		84332
	],
	"./Market/Index.vue": [
		37596
	],
	"./Market/LayoutPreferences.vue": [
		34456
	],
	"./Market/Orderbook/AggregationSelector.vue": [
		57814
	],
	"./Market/Orderbook/Header.vue": [
		40432
	],
	"./Market/Orderbook/Index.vue": [
		7363
	],
	"./Market/Orderbook/LayoutSelector.vue": [
		37924
	],
	"./Market/Orderbook/Record.vue": [
		43854
	],
	"./Market/Orderbook/SummaryPopup.vue": [
		28121
	],
	"./Market/Stats/Index.vue": [
		58553
	],
	"./Market/Stats/Partials/Index.vue": [
		2294
	],
	"./Market/Stats/Partials/LastTradedPriceAndChange.vue": [
		11818
	],
	"./Market/Stats/Partials/NextFunding.vue": [
		41187
	],
	"./Market/Stats/Partials/Settlement.vue": [
		88990
	],
	"./Market/Trades/Header.vue": [
		85608
	],
	"./Market/Trades/Index.vue": [
		91482
	],
	"./Market/Trades/Item.vue": [
		68550
	],
	"./OrderDetails/ExpectedPoints.vue": [
		29686
	],
	"./OrderDetails/FeeRate.vue": [
		80895
	],
	"./OrderDetails/FeeRebate.vue": [
		679
	],
	"./OrderDetails/Index.vue": [
		4333
	],
	"./OrderDetails/MakerTakerFeeRate.vue": [
		79782
	],
	"./Sidebar/Index.vue": [
		31505
	],
	"./Sidebar/MarketsFilter.vue": [
		46767
	],
	"./Sidebar/MarketsTable.vue": [
		5891
	],
	"./Sidebar/MarketsTableRow.vue": [
		72506
	],
	"./Spot/Orders.vue": [
		46124,
		6146,
		8837,
		2652,
		6124
	],
	"./Spot/Trading/Form.vue": [
		2163,
		2163
	],
	"./Spot/Trading/OrderDetails.vue": [
		45220,
		5220
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6102;
module.exports = webpackAsyncContext;